import { render } from "./message-custom.vue?vue&type=template&id=508c042d&scoped=true&ts=true"
import script from "./message-custom.vue?vue&type=script&lang=ts"
export * from "./message-custom.vue?vue&type=script&lang=ts"

import "./message-custom.vue?vue&type=style&index=0&id=508c042d&lang=scss&scoped=true"

import exportComponent from "/Users/ls/Documents/维思英才/webchat/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-508c042d"]])

export default __exports__